import ApiService from '@/services/core/api.service'

const VehicleTypeService = {
  async get (query) {
    return ApiService.get(`logistics-officer/vehicle-types?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/vehicle-types', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/vehicle-types/${payload.id}`, payload)
  }
}

export default VehicleTypeService
